import { getFormattedDate } from '@/src/utils/date'

export type MulticityUrlSegment = {
    from: { airportCode?: string; value?: string | null }
    to: { airportCode?: string; value?: string | null }
    date: Date | null
}

export type BuildMulticitySearchUrlInput = {
    segments: MulticityUrlSegment[]
    adults: number
    childs: number
    infants: number
    flightClass: string
    locale: string
    maxSegments?: number
    isNonStop?: boolean
    /** Used for the new SRP URL when already on SRP (defaults to `/${locale}/flights/results`). */
    newUrlPathname?: string
}

export const buildMulticitySearchUrl = ({
    segments,
    adults,
    childs,
    infants,
    flightClass,
    locale,
    isNonStop,
    newUrlPathname
}: BuildMulticitySearchUrlInput): string => {
    const queryParams = new URLSearchParams()

    segments.forEach((segment, index) => {
        const segmentNum = index + 1
        queryParams.set(`dep${segmentNum}`, segment.from.airportCode || '')
        queryParams.set(`arr${segmentNum}`, segment.to.airportCode || '')
        queryParams.set(`depdate${segmentNum}`, segment.date ? getFormattedDate(segment.date, 'DD/MM/YYYY') : '')
        queryParams.set(`origin${segmentNum}`, (segment.from.value as string) || '')
        queryParams.set(`destination${segmentNum}`, (segment.to.value as string) || '')
    })

    queryParams.set('adults', adults.toString())
    queryParams.set('childs', childs.toString())
    queryParams.set('infants', infants.toString())
    queryParams.set('class', flightClass)

    if (isNonStop) {
        queryParams.set('nonstop', '0')
    }

    const pathname = newUrlPathname ?? `/${locale}/flights/results`
    return `${pathname}?${queryParams.toString()}`
}
